import { onlineManager } from '@tanstack/react-query';
import { productGridRepositoryOfflineAdapters } from '../../../modules/offline/offlineRequestAdapters/productGrid.repository.offlineAdapters';
import { onlineProductGridRepository } from './productGridRepository/onlineProductGrid.repository';

export const getProductGridRepository = (isOfflineMode?: boolean) =>
  !onlineManager.isOnline() || isOfflineMode
    ? productGridRepositoryOfflineAdapters
    : onlineProductGridRepository;
